module.exports = __webpack_public_path__ + "img/banner_05.a9c23f63.jpg";